var path = '/pages/billing/invoices/views/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing/invoices/views/list.tpl.html
// module id = 2195
// module chunks = 1